import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { TABLE_HEADER_BORDER_STYLE } from './tableConst';
const StyledTableHeaderCell = styled('th', ({ $columnIndex, $totalColumns, $textAlign = 'left' }) => {
    const isNotLastColumn = $columnIndex < $totalColumns - 1;
    return {
        backgroundColor: staticColors.tableHeaderBackground,
        borderRight: isNotLastColumn ? TABLE_HEADER_BORDER_STYLE : 'none',
        textAlign: $textAlign,
    };
});
export const TableHeaderCell = ({ title, columnIndex, textAlign, totalColumns, testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsx(StyledTableHeaderCell, { $columnIndex: columnIndex, $textAlign: textAlign, $totalColumns: totalColumns, ...testIdAttribute, children: _jsx(Box, { spacingVertical: '3/4', spacingHorizontal: true, children: _jsx(Text, { variant: 'h6', as: 'div', children: title }) }) }));
};
